<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2503 15.125H5.74983C11.3752 15.125 13.2503 13.0795 13.2503 7.62477V15.125Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.25 7.25C13.4571 7.25 13.625 7.4179 13.625 7.62501V15.1253C13.625 15.3324 13.4571 15.5003 13.25 15.5003H5.74977C5.54265 15.5003 5.37476 15.3324 5.37476 15.1253C5.37476 14.9182 5.54265 14.7503 5.74977 14.7503C8.53468 14.7503 10.2789 14.2401 11.3418 13.1579C12.4062 12.0741 12.875 10.3281 12.875 7.62501C12.875 7.4179 13.0429 7.25 13.25 7.25ZM12.875 12.1988C12.6193 12.768 12.2905 13.2624 11.8769 13.6834C11.4413 14.1269 10.922 14.4789 10.3144 14.7503H12.875V12.1988Z"
      fill="currentColor"
    />
    <path
      d="M13.2503 15.125H5.74983C11.3752 15.125 13.2503 17.1705 13.2503 22.6253V15.125Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.25 23C13.4571 23 13.625 22.8321 13.625 22.625V15.1253C13.625 14.9182 13.4571 14.7498 13.25 14.7498L5.74977 14.7503C5.54265 14.7503 5.37476 14.9182 5.37476 15.1253C5.37476 15.3324 5.54265 15.5003 5.74977 15.5003C8.53468 15.5003 10.2789 16.0099 11.3418 17.0922C12.4062 18.1759 12.875 19.9219 12.875 22.625C12.875 22.8321 13.0429 23 13.25 23ZM12.875 18.0513C12.6193 17.4821 12.2905 16.9877 11.8769 16.5666C11.4413 16.1231 10.922 15.7712 10.3144 15.4998H12.875V18.0513Z"
      fill="currentColor"
    />
    <path
      d="M13.2503 15.125H20.7506C15.1253 15.125 13.2503 13.0795 13.2503 7.62477V15.125Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.25 7.25C13.0429 7.25 12.875 7.4179 12.875 7.62501L12.8754 15.1253C12.8754 15.3324 13.0429 15.5003 13.25 15.5003H20.7507C20.9578 15.5003 21.1257 15.3324 21.1257 15.1253C21.1257 14.9182 20.9578 14.7503 20.7507 14.7503C17.9658 14.7503 16.2216 14.2401 15.1587 13.1579C14.0943 12.0741 13.625 10.3281 13.625 7.62501C13.625 7.4179 13.4571 7.25 13.25 7.25ZM13.6255 12.1988C13.8812 12.768 14.21 13.2624 14.6236 13.6834C15.0591 14.1269 15.5785 14.4789 16.186 14.7503H13.6255V12.1988Z"
      fill="currentColor"
    />
    <path
      d="M13.2503 15.125H20.7506C15.1253 15.125 13.2503 17.1705 13.2503 22.6253V15.125Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.25 23C13.0429 23 12.875 22.8321 12.875 22.625L12.8754 15.1253C12.8754 14.9182 13.0429 14.7498 13.25 14.7498L20.7507 14.7503C20.9578 14.7503 21.1257 14.9182 21.1257 15.1253C21.1257 15.3324 20.9578 15.5003 20.7507 15.5003C17.9658 15.5003 16.2216 16.0099 15.1587 17.0922C14.0943 18.1759 13.625 19.9219 13.625 22.625C13.625 22.8321 13.4571 23 13.25 23ZM13.6255 18.0513C13.8812 17.4821 14.21 16.9877 14.6236 16.5666C15.0591 16.1231 15.5785 15.7712 16.186 15.4998H13.6255V18.0513Z"
      fill="currentColor"
    />
    <path
      d="M6.62515 8.50013H3.0536C5.73227 8.50013 6.62515 7.52604 6.62515 4.92847V8.50013Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.62503 4.75C6.72365 4.75 6.8036 4.82995 6.8036 4.92858V8.50024C6.8036 8.59887 6.72365 8.67883 6.62503 8.67883H3.05357C2.95495 8.67883 2.875 8.59887 2.875 8.50024C2.875 8.40161 2.95495 8.32166 3.05357 8.32166C4.37968 8.32166 5.21023 8.07874 5.71637 7.56337C6.22323 7.04727 6.44645 6.21583 6.44645 4.92858C6.44645 4.82995 6.5264 4.75 6.62503 4.75ZM6.44645 7.10663C6.32469 7.37769 6.1681 7.61312 5.97117 7.81364C5.76377 8.02482 5.51645 8.19242 5.22717 8.32166H6.44645V7.10663Z"
      fill="currentColor"
    />
    <path
      d="M6.62515 8.50013H3.0536C5.73227 8.50013 6.62515 9.47422 6.62515 12.0718V8.50013Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.62503 12.2503C6.72365 12.2503 6.8036 12.1703 6.8036 12.0717V8.50024C6.8036 8.40161 6.72365 8.32143 6.62503 8.32143L3.05357 8.32166C2.95495 8.32166 2.875 8.40161 2.875 8.50024C2.875 8.59887 2.95495 8.67883 3.05357 8.67883C4.37968 8.67883 5.21023 8.92151 5.71637 9.43689C6.22323 9.95299 6.44645 10.7844 6.44645 12.0717C6.44645 12.1703 6.5264 12.2503 6.62503 12.2503ZM6.44645 9.89363C6.32469 9.62256 6.1681 9.38714 5.97117 9.18662C5.76377 8.97543 5.51645 8.80783 5.22717 8.67859H6.44645V9.89363Z"
      fill="currentColor"
    />
    <path
      d="M6.62515 8.50013H10.1967C7.51799 8.50013 6.62515 7.52604 6.62515 4.92847V8.50013Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.62503 4.75C6.5264 4.75 6.44645 4.82995 6.44645 4.92858L6.44666 8.50024C6.44666 8.59887 6.5264 8.67883 6.62503 8.67883H10.1967C10.2953 8.67883 10.3753 8.59887 10.3753 8.50024C10.3753 8.40161 10.2953 8.32166 10.1967 8.32166C8.87057 8.32166 8.04003 8.07874 7.53389 7.56337C7.02703 7.04727 6.8036 6.21583 6.8036 4.92858C6.8036 4.82995 6.72365 4.75 6.62503 4.75ZM6.8038 7.10663C6.92556 7.37769 7.08215 7.61312 7.27908 7.81364C7.48648 8.02482 7.7338 8.19242 8.02308 8.32166H6.8038V7.10663Z"
      fill="currentColor"
    />
    <path
      d="M6.62515 8.50013H10.1967C7.51799 8.50013 6.62515 9.47422 6.62515 12.0718V8.50013Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.62503 12.2503C6.5264 12.2503 6.44645 12.1703 6.44645 12.0717L6.44666 8.50024C6.44666 8.40161 6.5264 8.32143 6.62503 8.32143L10.1967 8.32166C10.2953 8.32166 10.3753 8.40161 10.3753 8.50024C10.3753 8.59887 10.2953 8.67883 10.1967 8.67883C8.87057 8.67883 8.04003 8.92151 7.53389 9.43689C7.02703 9.95299 6.8036 10.7844 6.8036 12.0717C6.8036 12.1703 6.72365 12.2503 6.62503 12.2503ZM6.8038 9.89363C6.92556 9.62256 7.08215 9.38714 7.27908 9.18662C7.48648 8.97543 7.7338 8.80783 8.02308 8.67859H6.8038V9.89363Z"
      fill="currentColor"
    />
    <path
      d="M11.6253 3.50008H9.24431C11.0301 3.50008 11.6253 2.85069 11.6253 1.11898V3.50008Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6253 1C11.691 1 11.7443 1.0533 11.7443 1.11906V3.50016C11.7443 3.56592 11.691 3.61922 11.6253 3.61922H9.24429C9.17854 3.61922 9.12524 3.56592 9.12524 3.50016C9.12524 3.43441 9.17854 3.38111 9.24429 3.38111C10.1284 3.38111 10.6821 3.21916 11.0195 2.87558C11.3574 2.53151 11.5062 1.97722 11.5062 1.11906C11.5062 1.0533 11.5595 1 11.6253 1ZM11.5062 2.57108C11.425 2.7518 11.3206 2.90875 11.1894 3.04242C11.0511 3.18321 10.8862 3.29495 10.6934 3.38111H11.5062V2.57108Z"
      fill="currentColor"
    />
    <path
      d="M11.6253 3.50008H9.24431C11.0301 3.50008 11.6253 4.14948 11.6253 5.88119V3.50008Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6253 6.00017C11.691 6.00017 11.7443 5.94687 11.7443 5.88111V3.50016C11.7443 3.43441 11.691 3.38095 11.6253 3.38095L9.24429 3.38111C9.17854 3.38111 9.12524 3.43441 9.12524 3.50016C9.12524 3.56592 9.17854 3.61922 9.24429 3.61922C10.1284 3.61922 10.6821 3.78101 11.0195 4.12459C11.3574 4.46866 11.5062 5.02295 11.5062 5.88111C11.5062 5.94687 11.5595 6.00017 11.6253 6.00017ZM11.5062 4.42909C11.425 4.24837 11.3206 4.09142 11.1894 3.95774C11.0511 3.81696 10.8862 3.70522 10.6934 3.61906H11.5062V4.42909Z"
      fill="currentColor"
    />
    <path
      d="M11.6253 3.50008H14.0063C12.2206 3.50008 11.6253 2.85069 11.6253 1.11898V3.50008Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6253 1C11.5595 1 11.5062 1.0533 11.5062 1.11906L11.5063 3.50016C11.5063 3.56592 11.5595 3.61922 11.6253 3.61922H14.0064C14.0721 3.61922 14.1254 3.56592 14.1254 3.50016C14.1254 3.43441 14.0721 3.38111 14.0064 3.38111C13.1223 3.38111 12.5686 3.21916 12.2312 2.87558C11.8933 2.53151 11.7443 1.97722 11.7443 1.11906C11.7443 1.0533 11.691 1 11.6253 1ZM11.7444 2.57108C11.8256 2.7518 11.93 2.90875 12.0613 3.04242C12.1996 3.18321 12.3644 3.29495 12.5573 3.38111H11.7444V2.57108Z"
      fill="currentColor"
    />
    <path
      d="M11.6253 3.50008H14.0063C12.2206 3.50008 11.6253 4.14948 11.6253 5.88119V3.50008Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6253 6.00017C11.5595 6.00017 11.5062 5.94687 11.5062 5.88111L11.5063 3.50016C11.5063 3.43441 11.5595 3.38095 11.6253 3.38095L14.0064 3.38111C14.0721 3.38111 14.1254 3.43441 14.1254 3.50016C14.1254 3.56592 14.0721 3.61922 14.0064 3.61922C13.1223 3.61922 12.5686 3.78101 12.2312 4.12459C11.8933 4.46866 11.7443 5.02295 11.7443 5.88111C11.7443 5.94687 11.691 6.00017 11.6253 6.00017ZM11.7444 4.42909C11.8256 4.24837 11.93 4.09142 12.0613 3.95774C12.1996 3.81696 12.3644 3.70522 12.5573 3.61906H11.7444V4.42909Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'Pro' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
